/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_GroupInputs */



/**
* | output |
* | --- |
* | "Create Group" |
*
* @param {Create_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_group = /** @type {((inputs?: Create_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer le groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать группу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループを作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह बनाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar grupo")
	return /** @type {LocalizedString} */ ("Create Group")
});